import React from 'react';
import SubscribeComponent from '../../components/home/Subscribe/Subscribe';
import styles from './NewsLetter.module.css';

const Subscribe: React.FC = () => {
  return (
    <div className={styles.subscribePage}>
      {/* Hero Section */}
      <section className={styles.hero}>
        <div className={styles.heroContainer}>
          <div className={styles.heroContent}>
            <span className={styles.badge}>Newsletter</span>
            <h1 className={styles.title}>
              Subscribe <span className={styles.gradient}>FREE</span> Now!
            </h1>
            <p className={styles.subtitle}>
              Get the latest startup news, business insights, and exclusive stories 
              delivered straight to your inbox. Join thousands of entrepreneurs who 
              trust Startuprahi for their daily dose of innovation.
            </p>

            {/* Benefits */}
            <div className={styles.benefits}>
              <div className={styles.benefit}>
                <div className={styles.benefitIcon}>✨</div>
                <div>
                  <h3>Exclusive Content</h3>
                  <p>Access premium articles and insider stories</p>
                </div>
              </div>
              <div className={styles.benefit}>
                <div className={styles.benefitIcon}>📰</div>
                <div>
                  <h3>Daily Updates</h3>
                  <p>Stay informed with the latest startup news</p>
                </div>
              </div>
              <div className={styles.benefit}>
                <div className={styles.benefitIcon}>🎯</div>
                <div>
                  <h3>Curated Insights</h3>
                  <p>Handpicked stories that matter to you</p>
                </div>
              </div>
              <div className={styles.benefit}>
                <div className={styles.benefitIcon}>🚀</div>
                <div>
                  <h3>Early Access</h3>
                  <p>Be the first to know about trending startups</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Subscribe Component */}
      <section className={styles.subscribeSection}>
        <div className={styles.subscribeContainer}>
          <SubscribeComponent />
        </div>
      </section>

      {/* Why Subscribe Section */}
      <section className={styles.whySection}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>Why Subscribe to Startuprahi?</h2>
          
          <div className={styles.featuresGrid}>
            <div className={styles.featureCard}>
              <div className={styles.featureIconWrapper}>
                <span className={styles.featureIcon}>📊</span>
              </div>
              <h3>Market Insights</h3>
              <p>Deep analysis of market trends, funding rounds, and industry movements</p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIconWrapper}>
                <span className={styles.featureIcon}>💡</span>
              </div>
              <h3>Innovation Stories</h3>
              <p>Discover groundbreaking ideas and cutting-edge technologies</p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIconWrapper}>
                <span className={styles.featureIcon}>🏆</span>
              </div>
              <h3>Success Stories</h3>
              <p>Learn from successful entrepreneurs and their journeys</p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIconWrapper}>
                <span className={styles.featureIcon}>💰</span>
              </div>
              <h3>Funding News</h3>
              <p>Latest updates on investments, acquisitions, and valuations</p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIconWrapper}>
                <span className={styles.featureIcon}>🌟</span>
              </div>
              <h3>Recognition</h3>
              <p>Awards, achievements, and milestones in the startup world</p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIconWrapper}>
                <span className={styles.featureIcon}>🔔</span>
              </div>
              <h3>Breaking News</h3>
              <p>Real-time alerts on major announcements and industry updates</p>
            </div>
          </div>
        </div>
      </section>


      {/* Testimonials */}
      <section className={styles.testimonialsSection}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>What Our Subscribers Say</h2>
          
          <div className={styles.testimonialsGrid}>
            <div className={styles.testimonialCard}>
              <div className={styles.quote}>"</div>
              <p className={styles.testimonialText}>
                "Startuprahi's newsletter is my daily dose of inspiration. The curated 
                content helps me stay ahead in the startup ecosystem."
              </p>
              <div className={styles.author}>
                <div className={styles.authorAvatar}>R</div>
                <div>
                  <div className={styles.authorName}>Rahul Verma</div>
                  <div className={styles.authorTitle}>Founder, TechStartup</div>
                </div>
              </div>
            </div>

            <div className={styles.testimonialCard}>
              <div className={styles.quote}>"</div>
              <p className={styles.testimonialText}>
                "Best startup news platform! I love how they cover early-stage companies 
                and provide actionable insights for entrepreneurs."
              </p>
              <div className={styles.author}>
                <div className={styles.authorAvatar}>P</div>
                <div>
                  <div className={styles.authorName}>Priya Singh</div>
                  <div className={styles.authorTitle}>Venture Capitalist</div>
                </div>
              </div>
            </div>

            <div className={styles.testimonialCard}>
              <div className={styles.quote}>"</div>
              <p className={styles.testimonialText}>
                "As an aspiring entrepreneur, Startuprahi gives me the knowledge and 
                confidence to pursue my startup dreams. Highly recommended!"
              </p>
              <div className={styles.author}>
                <div className={styles.authorAvatar}>A</div>
                <div>
                  <div className={styles.authorName}>Amit Patel</div>
                  <div className={styles.authorTitle}>MBA Student</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Subscribe;